document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation for better performance
  document.getElementById('disclosure__toggle__header')?.addEventListener('click', function(event) {
    // Remove console.log to reduce execution overhead
    const disclosureList = this.querySelector('.disclosure-list');
    if (disclosureList) {
      disclosureList.classList.toggle('disclosure-list--visible');
    }
  });

  // Process external links only after the main content has loaded
  window.addEventListener('load', function() {
    // Use native querySelectorAll for better performance
    const links = document.querySelectorAll('a[href^="http"]');
    const hostname = window.location.hostname;
    
    // Use forEach which is more efficient than a traditional for loop
    links.forEach(function(link) {
      if (link.hostname !== hostname) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
      }
    });
  });
});